import { render, staticRenderFns } from "./dtd.vue?vue&type=template&id=9547ba44"
import script from "./dtd.vue?vue&type=script&lang=js"
export * from "./dtd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports